import styled from 'styled-components';

export default styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 2px;
`;
